var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.$t('SYSTEM_REMIND_ME_PASSWORD')))]),_c('RemindPasswordForm',{attrs:{"onSubmit":_vm.remindPassword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }